import { Col, Row } from 'antd';
import styles from './aboutus.module.less';
import { CandidateLayout, SEO_COMMON } from '../../layout/candidate/CandidateLayout';
import { TextHeading, TextSpan } from '../../uicomp/atmos/content-block/ContentBlock';
import Image from 'next/image';
import { NextSeo } from 'next-seo';

export const AboutUs = () => {
  return (
    <CandidateLayout
      title={
        <NextSeo
          canonical="https://www.careers360.lk/about-us"
          title={'About Us'}
          {...SEO_COMMON}
        />
      }>
      <div className={styles.container}>
        <Row>
          <Col lg={11} md={24} sm={24} xs={24}>
            {/*<p className={styles.title}>*/}
            {/*  Recruitment made easy with{' '}*/}
            {/*  <a href="/" className={styles.titlelink}>*/}
            {/*    Careers360{' '}*/}
            {/*  </a>*/}
            {/*</p>*/}
            <TextHeading heading level={3} id={'about-us-title'}>
              Recruitment made easy with{' '}
              <TextSpan heading primary level={3}>
                Careers360
              </TextSpan>
            </TextHeading>

            <p className={styles.para1}>
              Are you a job seeker frustrated with the lack of transparency because you have no idea
              what has happened with your application?
            </p>
            <p className={styles.para2}>
              Are you a recruiter looking for to ensure guaranteed placement with the right fit your
              advertisement?
            </p>

            <h3 className={styles.iconhead}>
              <img
                className={styles.icon}
                src="https://unroll-images-production.s3.amazonaws.com/projects/3657/1641800765371-briefcase-case-work-bag-suitcase-stationary-44555.png"
              />{' '}
              {"Well, that's what we are here for!"}
            </h3>
            <br />
            <a href="/" className={styles.homelink}>
              Careers360{' '}
            </a>
            <p className={styles.para3}>
              is a powerful, user-friendly recruitment software that scales your ability to find and
              hire great talent by leveraging the power of thoughtful technology to make the process
              of recruitment, hassle-free.
            </p>

            <p className={styles.para3}>
              Today, the pandemic and the resulting economic conditions in countries around the
              world has caused unparalleled disruption worldwide and a devastating impact on
              employment and livelihood. The job market has changed irreversibly, and unemployment
              rates are also at an all-time high.
            </p>

            <p className={styles.para3}>
              At a time of instability and vulnerability, our simple vision is to help connect
              people with ample opportunities by transforming the way employers and career-seekers
              experience recruitment.
            </p>
          </Col>
          <Col lg={13} md={24} sm={24} xs={24}>
            <div className={styles.imageicon}>
              <Image
                className={styles.aboutImage}
                width={500}
                height={500}
                src="https://unroll-images-production.s3.amazonaws.com/projects/3657/1641807627631-aboutus-image.svg"
                alt={'about us c360'}
              />
            </div>
          </Col>
        </Row>
      </div>
    </CandidateLayout>
  );
};
